import { type GuardStatus } from '@capsicum/common';
import { useAtomValue } from 'jotai';

import { ncwTransferAmountAtom } from '../data-access';

export const useNCWTransferAmountGuardStatus = (): GuardStatus =>
	useAtomValue(ncwTransferAmountAtom) === undefined ? 'denied' : 'allowed';
